export const PLAN_FEATURES = {
  NO_MEAL: '18123456791827',
  CREDIT_CARD_ONLY: '18123456791700',
};
export const PAY_AT_HOTEL = 'PAY_AT_HOTEL';
